import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link, useHistory} from 'react-router-dom';
import {Dropdown, DropdownButton} from 'react-bootstrap';
import {useSelector} from 'react-redux';
import {ReactComponent as DataFeedIcon} from '@app/assets/svg/data-entry.svg';
import {ReactComponent as ValidationsIcon} from '@app/assets/svg/validations.svg';
import {ReactComponent as ReportsIcon} from '@app/assets/svg/reports.svg';
import {
  ROLE_DATA_REPORTER,
  ROLE_EXECUTIVE_REPORTER,
  ROLE_VALIDATOR,
} from '@app/utils/constants';
import User from './user-dropdown/UserDropdown';

const REPORTER_NAV = [
  {
    path: '/reporter',
    name: 'reporterAbout',
    icon: <i className="fa fa-home text-center" style={{width: '32px'}} />,
    roles: [ROLE_EXECUTIVE_REPORTER],
  },
  {
    path: '/activities',
    name: 'reporterData',
    icon: <DataFeedIcon className="reporter-navbar-item-svg-icon" />,
    roles: [ROLE_EXECUTIVE_REPORTER, ROLE_DATA_REPORTER],
  },
  {
    path: '/reporter/validations',
    name: 'reporterValidation',
    icon: <ValidationsIcon className="reporter-navbar-item-svg-icon" />,
    roles: [ROLE_VALIDATOR],
  },
  {
    path: '/reports',
    name: 'reporterReports',
    icon: <ReportsIcon className="reporter-navbar-item-svg-icon" />,
    roles: [ROLE_EXECUTIVE_REPORTER, ROLE_DATA_REPORTER],
  },
];

const HeaderMain = ({toggleMenuSidebar}) => {
  const [t] = useTranslation();
  const history = useHistory();
  const [activeNavItem, setActiveNavItem] = useState('');
  const currentUser = useSelector((state) => state.auth.currentUser);

  const handleSetActiveNavItem = (pathname) => {
    const foundItem = REPORTER_NAV.find((item) => item.path === pathname);
    setActiveNavItem(foundItem ? foundItem.name : '');
  };

  useEffect(() => {
    handleSetActiveNavItem(history.location.pathname);
    return history.listen((location) => {
      handleSetActiveNavItem(location.pathname);
    });
  }, [history]);

  const getFilteredReporterNav = () => {
    let currentRole = '';
    const CURRENT_ROLES = currentUser.Roles || [];
    if (CURRENT_ROLES.includes(ROLE_EXECUTIVE_REPORTER)) {
      currentRole = ROLE_EXECUTIVE_REPORTER;
    } else if (CURRENT_ROLES.includes(ROLE_DATA_REPORTER)) {
      currentRole = ROLE_DATA_REPORTER;
    } else if (CURRENT_ROLES.includes(ROLE_VALIDATOR)) {
      currentRole = ROLE_VALIDATOR;
    }
    return REPORTER_NAV.filter((navItem) =>
      navItem.roles.includes(currentRole)
    );
  };

  const renderReporterNav = () => {
    return getFilteredReporterNav().map((item) => (
      <li
        key={`nav-item-${item.name}`}
        className={`nav-item d-none reporter-nav-item d-lg-block${
          activeNavItem === item.name ? ' active' : ''
        }`}
      >
        <Link
          to={item.path}
          onClick={() => handleSetActiveNavItem(item.path)}
          className="nav-link reporter-nav-link"
        >
          {item.icon}
          {t(`header.label.${item.name}`)}
        </Link>
      </li>
    ));
  };

  const renderReporterNavMobile = () => {
    return getFilteredReporterNav().map((item) => (
      <Dropdown.Item
        onClick={() => {
          history.push(item.path);
          handleSetActiveNavItem(item.path);
        }}
        key={`nav-dp-item-${item.name}`}
        className={`reporter-nav-link${
          activeNavItem === item.name ? ' active' : ''
        }`}
      >
        {item.icon}
        {t(`header.label.${item.name}`)}
      </Dropdown.Item>
    ));
  };

  const renderReporterDropdownTitle = () => {
    const foundItem = REPORTER_NAV.find((item) => item.name === activeNavItem);
    if (foundItem) {
      return (
        <div className="d-inline-block ">
          {foundItem.icon}
          <span>{t(`header.label.${foundItem.name}`)}</span>
        </div>
      );
    }
    return <div className="d-inline-block">Actions</div>;
  };

  const renderHeaderNav = () => {
    const USER_ROLES = currentUser.Roles || [];
    if (
      USER_ROLES.includes(ROLE_EXECUTIVE_REPORTER) ||
      USER_ROLES.includes(ROLE_DATA_REPORTER)
    ) {
      return (
        <>
          {renderReporterNav()}
          <DropdownButton
            menuAlign="right"
            variant="link"
            size="sm"
            title={renderReporterDropdownTitle()}
            id="dropdown-menu-align-reporter-actions"
            className="reporter-dp-actions mt-1 d-inline-block d-lg-none"
          >
            {renderReporterNavMobile()}
          </DropdownButton>
        </>
      );
    }
    return null;
  };

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light cce-sidebar-margin-left cce-mobile-header elevation-1">
      {/* Left navbar links */}
      <ul className="navbar-nav mx-0 mx-lg-auto">
        <li className="nav-item d-block d-lg-none">
          <button
            onClick={() => toggleMenuSidebar()}
            type="button"
            className="nav-link"
          >
            <i className="fas fa-bars" />
          </button>
        </li>
        {renderHeaderNav()}
      </ul>
      <ul className="navbar-nav ml-auto pr-lg-3 pr-0">
        <User />
      </ul>
    </nav>
  );
};

export default HeaderMain;
